import { george, observer, pr, React, RouteComponentProps, theme, ui, debug } from "aaa";
import { pushRoute } from "stores/RouterFunctions";
import { ISigningResponse } from "types/signing";
import { SigningComponent } from "../signing/views/SigningComponent";
import { TeamcardLinkageStore } from "./TeamcardLinkageStore";
import { TeamcardLinkageRoutes } from "./TeamcardLinkageRoutes";
import { safeWindowOpen } from "util/helpers";

type IProps = RouteComponentProps<{}> & {
    store: TeamcardLinkageStore;
};

@observer
export class TeamcardLinkageSigning extends React.Component<IProps, {}> {
    render() {
        return (
            <SigningComponent
                useWebVersion
                signingInfo={this.props.store.signInfo}
                content={
                    <>
                        <div style={{ padding: theme.MARGIN }}>
                            <george.SectionTitle style={{ marginTop: 0 }}>
                                {ui.__("common.summary")}
                            </george.SectionTitle>
                            <pr.LightSeparatorLine spacing={theme.MARGIN} />
                            <george.ResponsiveSummaryElement label={ui.__("teamcardLinkage.company")}>
                                <pr.SigningLabel>
                                    {this.props.store.invitationData?.card.company.name}
                                </pr.SigningLabel>
                            </george.ResponsiveSummaryElement>
                            <george.ResponsiveSummaryElement label={ui.__("teamcardLinkage.cardHolder")}>
                                <pr.SigningLabel>{this.props.store.invitationData?.card.cardHolderName}</pr.SigningLabel>
                            </george.ResponsiveSummaryElement>
                            <george.ResponsiveSummaryElement label={ui.__("teamcardLinkage.cardProduct")}>
                                <pr.SigningLabel>{this.props.store.invitationData?.card.product}</pr.SigningLabel>
                            </george.ResponsiveSummaryElement>
                            <george.ResponsiveSummaryElement label={ui.__("common.approval")}>
                                <pr.SigningLabel>{ui.__("teamcardLinkage.signing.legal.note")}</pr.SigningLabel>
                            </george.ResponsiveSummaryElement>
                            <br />
                            <pr.SigningLabel>{ui.__("teamcardLinkage.signing.info")}</pr.SigningLabel>

                        </div>
                    </>

                }
                onError={async (response: ISigningResponse) => {
                    debug.log("### signing error", response);
                    pushRoute("/error");
                    // safeWindowOpen("ggo://error");
                }}
                onSuccess={(response: ISigningResponse) => {
                    debug.log("### signing success", response);
                    pushRoute(TeamcardLinkageRoutes.SUCCESS);
                    // safeWindowOpen("ggo://success");
                }}
                onRetry={async () => {
                    await this.props.store.acceptInvitation();
                }}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/teamcardLinkage/TeamcardLinkageSigning.tsx